export default {"src":"/_next/static/media/landscape-design.533c866c.svg","height":21,"width":31,"blurWidth":0,"blurHeight":0};